/* ============================================================
   Site-wide: open the cart drawer on any add-to-cart
   - Watches fetch/XHR for POSTs to /cart/add(.js) and, on success,
     re-renders the drawer sections and opens it.
   - Add requests that already ask for `sections` are ignored: every
     in-theme path (product-form, quick-add, ritual-upsell, quick-order-list)
     requests sections and renders the drawer itself. This only picks up the
     callers that don't — Replo buy boxes, apps, custom snippets.
   Loaded from: snippets/cart-drawer.liquid (cart_type == 'drawer' only)
   ============================================================ */
(function () {
  'use strict';

  var ADD_URL = /\/cart\/add(\.js)?(\?|$)/;
  var COALESCE_MS = 100;
  var originalFetch = window.fetch;
  var timer = null;
  var inFlight = false;
  var again = false;

  // True when the caller already requested cart sections — it will render the
  // drawer itself, so we must stay out of the way.
  function requestsSections(body) {
    try {
      if (!body) return false;
      if (typeof body === 'string') return body.indexOf('sections') !== -1;
      if (typeof FormData !== 'undefined' && body instanceof FormData) return body.has('sections');
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.has('sections');
    } catch (e) {}
    return false;
  }

  function schedule() {
    if (inFlight) { again = true; return; }
    clearTimeout(timer);
    timer = setTimeout(refreshAndOpen, COALESCE_MS);
  }

  function refreshAndOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    inFlight = true;
    var sections = drawer.getSectionsToRender().map(function (s) { return s.id; });

    originalFetch.call(window, '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: {}, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // Clear the empty-cart state so items are visible when adding to an
        // empty cart (mirrors the theme's product-form.js behaviour).
        drawer.classList.remove('is-empty');
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');

        drawer.setActiveElement(document.activeElement);
        drawer.renderContents(cart); // renderContents() opens the drawer itself

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-auto-open', cartData: cart });
        }
      })
      .catch(function (e) { console.error('[cart-drawer-auto-open]', e); })
      .then(function () {
        inFlight = false;
        if (again) { again = false; schedule(); }
      });
  }

  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var body = init && init.body;
      var watch = ADD_URL.test(url) && !requestsSections(body);
      var result = originalFetch.apply(this, arguments);
      if (!watch) return result;
      return result.then(function (response) {
        // 422 = sold out / invalid variant: leave the drawer closed.
        if (response && response.ok) schedule();
        return response;
      });
    };
  }

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this._cartAdd = ADD_URL.test(url || '');
      return open.apply(this, arguments);
    };

    XHR.prototype.send = function (body) {
      if (this._cartAdd && !requestsSections(body)) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) schedule();
        });
      }
      return send.apply(this, arguments);
    };
  }
})();
